import { render, staticRenderFns } from "./VisitRate.vue?vue&type=template&id=be46274e&scoped=true"
import script from "./VisitRate.vue?vue&type=script&lang=js"
export * from "./VisitRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be46274e",
  null
  
)

export default component.exports